/**
 * 使用a标签来下载
 */
const downloadApp = (url) => {
    const a = document.createElement('a')
    a.setAttribute('download', '')
    a.setAttribute('href', url)
    a.click()
}

export default downloadApp
